<template>
  <div>
    <div class="filter_form uk-grid">
      <div class="filter_select filterkategorie uk-width-1-4">
        <select
          v-model="currentGruppe"
          class="filter_form_elem uk-select"
          name="kategorie"
        >
          <option value="0">
            Für wen?
          </option>
          <option
            v-for="(gruppe, index) of gruppen"
            :key="index"
            :value="gruppe.uid"
          >
            {{ gruppe.titel }}
          </option>
        </select>
      </div>
      <div class="filter_select filterart uk-width-1-4">
        <select
          v-model="currentArten"
          class="filter_form_elem uk-select"
          name="art"
        >
          <option value="0">
            Themen und Inhalte
          </option>
          <option
            v-for="(art, index) of arten"
            :key="index"
            :value="art"
            v-text="art"
          />
        </select>
      </div>
      <div class="filter_data filterdate_von uk-width-1-4">
        <input
          class="filter_form_elem uk-input"
          :placeholder="dateSelectedLabel"
          type="input"
          name="datevon"
          @click="toggleDatePicker"
        >
        <span
          v-if="dateSelectedLabel != 'Zeitraum'"
          class="uk-icon clean_von"
          uk-icon="icon: close"
          @click="cleanDateVon"
        />
        <span
          v-else
          class="uk-icon clean_von"
          uk-icon="icon: calendar"
        />
      </div>
      <div class="filter_input filtersuche uk-width-1-4">
        <span class="uk-inline">
          <a
            class="uk-form-icon uk-form-icon-flip"
            href="#"
            uk-icon="icon: close"
            @click="sucheVolltext = ''"
          />
          <input
            v-model="sucheVolltext"
            class="filter_form_elem uk-input"
            type="text"
            name="suchbegriff"
            value=""
            placeholder="Suchbegriff / Kurs-Nr."
          >
        </span>
      </div>
    </div>
    <dateselect />
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
} from 'vuex';

import dateselect from './dateselect.vue';

export default {
  name: 'Kursfilter',
  components: {
    // Filterobj,
    dateselect,
  },
  data() {
    return {
      showDatepickerVon: false,
      showDatepickerBis: false,
      currentSearchInput: '',
    };
  },
  created() {
    console.log('kursfilter created');
  },

  methods: {
    ...mapMutations(['setFilter']),
    parseJsonFromFilterObj(filterObj) {
      return JSON.stringify(filterObj);
    },
    cleanDateVon() {
      this.setFilter({
        type: 'dateStart',
        val: null,
      });
      this.setFilter({
        type: 'dateEnd',
        val: null,
      });
      this.dateSelectedLabel = 'Zeitraum';
    },

    cleanDateBis() {
      const filterObj = {
        type: 'dateEnd',
        val: null,
      };
      this.setFilter(filterObj);
    },
    toggleDatePicker() {
      console.log('toggleDatePicker', UIkit);

      UIkit.modal(document.getElementById('date-select')).show();
    },
  },
  computed: {
    ...mapGetters(['kursliste', 'gruppen', 'filter', 'arten']),
    sucheVolltext: {
      get() {
        return this.filter.volltext;
      },
      set(value) {
        console.log(`set sucheVolltext: ${value}`);
        if (value.length > 0) {
          this.setFilter({
            type: 'volltext',
            val: value,
          });
        } else {
          this.setFilter({
            type: 'volltext',
            val: '',
          });
        }
      },
    },
    currentArten: {
      get() {
        if (this.filter.art) {
          return this.filter.art;
        }
        return 0;
      },
      set(value) {
        this.setFilter({
          type: 'art',
          //  val: Number(value),
          val: value,
        });
      },
    },
    currentGruppe: {
      get() {
        return this.filter.gruppe ? this.filter.gruppe : 0;
      },
      set(value) {
        this.setFilter({
          type: 'gruppe',
          val: Number(value),
        });
      },
    },
    dateSelectedLabel() {
      if (!this.filter.dateStart) {
        return 'Zeitraum';
      }
      if (this.filter.dateStart !== this.filter.dateEnd) {
        return `${this.filter.dateStart}-${this.filter.dateEnd}`;
      }
      return this.filter.dateStart;
    },
  },
};
</script>

<style>
.vfc-start-marked,
.vfc-end-marked {
  background-color: #ff6300 !important;
}
</style>
